export const selectUserName = state => state.user.login.username;
export const selectIsNotVerified = state => state.user.isNotVerified;
export const selectUserTheme = state => state.user.userTheme;
export const selectAccessToken = state => state.user.accessToken;
export const selectRefreshToken = state => state.user.refreshToken;
export const selectIsLoggined = state => state.user.isLoggined;
export const selectIsLoading = state => state.user.isLoading;
export const selectAvatar = state => state.user.userAvatar;
export const selectUserEmail = state => state.user.login.email;
export const selectError = state => state.user.error;
export const selectNotification = state => state.user.notification;
